module.exports = __webpack_public_path__ + "static/img/bannar01.f17b9418.png";